var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',[_c('div',{staticClass:"th-body",on:{"click":function($event){return _vm.toggleSort()}}},[_c('div',{staticClass:"th-body-inner"},[_vm._t("default")],2),_c('i',{staticClass:"la",class:_vm.iconClass})])])
}
var staticRenderFns = []

export { render, staticRenderFns }